import { useState, useEffect } from "react";

function inViewport(element) {
  if (!element) return false;
  if (1 !== element.nodeType) return false;

  var html = document.documentElement;
  var rect = element.getBoundingClientRect();
  
  return (
    !!rect &&
    rect.bottom >= 0 &&
    rect.right >= 0 &&
    rect.left <= html.clientWidth &&
    rect.top <= html.clientHeight
  );
}

const MobileMenu = (props) => {
  const { firmOrNetworkType, adviserCount, render, unclaimed, verifiedAdviserCount } = props;
  const [active, setActive] = useState("hero");

  useEffect(() => {
    window.addEventListener("scrollend", checkElInView);
  }, []);

  const checkElInView = () => {
    const elementList = [
      "hero",
      "advisers",
      "reviews",
      "firmServices",
      "about",
    ];
    elementList.every((element) => {
      const el = document.getElementById(element);
      if (inViewport(el)) {
        setActive(element)
        if (element === "hero") {
          const hero = document.getElementById("hero");
          const heroPos = hero ? hero.getBoundingClientRect().top : 0;
          if (heroPos >= 0) return false;
        }
        if (element === "advisers") {
          const adiviserSection = document.getElementById("advisers");
          if (adiviserSection) {
            const adviserPos = adiviserSection.getBoundingClientRect().top;
            //adviser section is roughly around 450px, if position is > -200 it means more than half of it is still on screen, 
            //so it should have the active state instead of the next section that is also in viewport at this point
            if (adviserPos > -200) return false;
          } 
        }
      }
      return true
    });
  };

  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const headerOffset = 50;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    
      window.scrollTo({
           top: offsetPosition,
           behavior: "smooth"
      });
      setActive(id)
    }
  }
 
  if (!render) return null

  return (
    <div className='flex gap-2 sticky top-0 bg-white justify-around py-4 z-10 text-sm [&_div]:text-secondary-blue'>
      <div
        href="#hero"
        onClick={() => handleScroll("hero")}
        className={active === "hero" ? 'font-bold underline cursor-pointer' : "cursor-pointer"}
      >
        Overview
      </div>
      {firmOrNetworkType === "network" ? (
        <>
          { adviserCount ? <div
            href="#advisers"
            onClick={() => handleScroll("advisers")}
            className={active === "advisers" ? 'font-bold underline cursor-pointer' : "cursor-pointer"}
          >
            Advisers
          </div> : null }
          <div
            href="#reviews"
            onClick={() => handleScroll("reviews")}
            className={active === "reviews" ? 'font-bold underline cursor-pointer' : "cursor-pointer"}
          >
            Reviews
          </div>
        </>
      ) : (
        <>
          { adviserCount ? <div
            href="#advisers"
            onClick={() => handleScroll("advisers")}
            className={active === "advisers" ? 'font-bold underline cursor-pointer' : "cursor-pointer"}
          >
            Advisers
          </div> : null}
          <div
            href="#reviews"
            onClick={() => handleScroll("reviews")}
            className={active === "reviews" ? 'font-bold underline cursor-pointer' : "cursor-pointer"}
          >
            Reviews
          </div>
          <div
            href="#about"
            onClick={() => handleScroll("about")}
            className={active === "about" ? 'font-bold underline cursor-pointer' : "cursor-pointer"}
          >
            About
          </div>
          { !unclaimed && verifiedAdviserCount > 0 ? <div
            href="#firmServices"
            onClick={() => handleScroll("firmServices")}
            className={active === "firmServices" ? 'font-bold underline cursor-pointer' : "cursor-pointer"}
          >
            Services
          </div> : null }
        </>
      )}
    </div>
  );
};

export default MobileMenu;
